export default __webpack_public_path__ + "static/media/item_4@3x.838a180e.webp";